import React from "react";
import { PieChart, Pie, Cell } from "recharts";

const COLORS = ["#4CAF50", "#E5E7EB"]; // green for completed, gray for remaining

const DonutChart = ({ percentage, title }) => {
  const data = [
    { name: "Completed", value: percentage },
    { name: "Remaining", value: 100 - percentage },
  ];

  return (
    <div className="flex flex-col items-center">
      <h2 className="text-md font-semibold mb-2">{title}</h2>
      <div className="relative flex items-center justify-center">
        <PieChart width={150} height={150}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={40}
            outerRadius={60}
            dataKey="value"
            stroke="none"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
        </PieChart>
        <span className="absolute text-xl font-bold">{percentage}%</span>
      </div>
    </div>
  );
};

export default DonutChart;
